export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";